<div class="wizard-container">
  <div class="header">
    <div class="title-section">
      <div class="main-title">What you will learn</div>
      <div class="sub-title">An overview of all courses!</div>
      <div class="explore-btn">
        <button>explore more</button>
      </div>
    </div>
    <div class="img-section">
      <img src="../../../assets/images/icon 09.jpg" alt="" />
    </div>
  </div>
  <div class="content">
    <div class="courses-section">
      <div class="top-section">
        <div class="title">Courses</div>
        <div class="add-btn" (click)="onAddCourse()"><button>Add</button></div>
      </div>
      <div class="list-section">
        <div class="course" *ngFor="let course of courses" (click)="onClickCourse(course)" [ngClass]="{'active': courseService.selectedCourse == course._id}">
          <div class="top">
            <div class="name">
              {{course.title}}
            </div>
            <div class="edit-btn" (click)="onEditCourse(course)">
              <i class="fa-solid fa-pen-to-square"></i>
            </div>
          </div>
          <div class="duration">{{course.price}}</div>
          <div class="desc">
            {{course.description}}
          </div>
        </div>
      </div>
    </div>
    <div class="modules-section">
      <div class="top-section">
        <div class="title">Modules</div>
        <div class="add-btn" [ngClass]="{'pointer-none':!courseService.selectedCourse}" (click)="onAddModule()"><button>Add</button></div>
      </div>
      <div class="list-section">
        <div class="module" *ngFor="let module of modules" (click)="onClickModule(module)" [ngClass]="{'active':courseService.selectedModule == module._id}">
          <div class="top">
            <div class="name">
              {{module.title}}
            </div>
            <div class="edit-btn" (click)="onEditModule(module)">
              <i class="fa-solid fa-pen-to-square"></i>
            </div>
          </div>
          <div class="duration">duration</div>
          <div class="desc">
           {{module.description}}
          </div>
        </div>
      </div>
    </div>
    <div class="lessons-section">
      <div class="top-section">
        <div class="title">Lessons</div>
        <div class="add-btn" [ngClass]="{'pointer-none':!courseService.selectedModule}"  (click)="onAddLesson()">
          <button>Add</button>
        </div>
      </div>
      <div class="list-section">
        <div class="lesson" *ngFor="let lesson of lessons" (click)="onClickLesson(lesson)" [ngClass]="{'active':courseService.selectedLesson==lesson._id}">
          <div class="top">
            <div class="name">
              {{lesson.title}}
            </div>
            <div class="edit-btn" (click)="onEditLesson(lesson)">
              <i class="fa-solid fa-pen-to-square"></i>
            </div>
            <td [style]="{ width: '5%' }">
              <div class="delete-icon" (click)="deleteLesson(lesson)">
                <i class="fa-solid fa-trash-can"></i>
              </div>
            </td>
          </div>
          <div class="duration">{{lesson.duration}}</div>
          <div class="desc">
           {{lesson.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <button *ngIf="courseService.selectedCourse && courseService.courseMode=='D'" (click)="publishCourse()">Publish</button>
    <button *ngIf="courseService.selectedCourse && courseService.courseMode=='P'" (click)="unPublishCourse()">Unpublish</button>
  </div>
</div>
